import { render } from "./ParametersSportRadarApiKey.vue?vue&type=template&id=2681d8b7"
import script from "./ParametersSportRadarApiKey.vue?vue&type=script&lang=js"
export * from "./ParametersSportRadarApiKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__